import { isIOS, isAndroid } from "react-device-detect";
import { getEnvs } from "./env";

export const onMobileAppDownloadClick = () => {
  if (!isIOS && !isAndroid) return;

  window.location.href = `${getEnvs().FIRELINKS_BASE_URL}/s/web_get_mobile_app_page`;
};
